import React from 'react'
import { createPortal } from 'react-dom'
import ReactDOM from 'react-dom'
import './loader.css'
const Loader = () => {
  return ReactDOM.createPortal (
    <div className='loader' style={{position:"fixed" , width:'100vw' , height:'100vh' , zIndex:'10' , backgroundColor:"black"}}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 2000 2000"
      xmlSpace="preserve"
      style={{width:'100%', height:'100%'}}
    >
      <style>{".st5{fill:#fff}"}</style>
      <path d="M0 0H2000V2000H0z" />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1={1016.5784}
        y1={1056.4142}
        x2={1191.8413}
        y2={1056.4142}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <path
        d="M1162.65 1109.22l-114.79-75.4-14.65-9.62-8.94-5.87-7.69-5.05 4.83-3.17 7.1-4.67h-.1l2.77-1.82 7.75 5.09 8.94 5.87 14.65 9.62 64.57 42.42a264.61 264.61 0 01-6.65-26.21l-41.29-27.13 11.93-7.84h-.1l2.77-1.82 41.25 27.09a248.217 248.217 0 0027.65 78.51z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SVGID_1_)"
      />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1={921.0189}
        y1={1000.1646}
        x2={1199.451}
        y2={1000.1646}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <path
        d="M921.02 1106.21a248.396 248.396 0 0027.66-78.51l35.13-23.08 6.46-4.25h-.1l3.42-2.25.99-.65 3.79-2.49 16.43-10.79 14.65-9.62 10.52-6.91 14.66-9.63 25.33-16.64 5.99-3.93 7.25-4.76 14.65-9.63 44.09-28.96a248.396 248.396 0 00-27.66 78.51l-38.82 25.5-2.77 1.82h.1l-11.93 7.84-16.63 10.92-14.65-9.62 13.26-8.71h-.1l3.42-2.25.99-.65 52.57-34.54c1.77-8.85 3.99-17.61 6.65-26.21l-47.09 30.93-5.23 3.44-19.93 13.1-9.24 6.07-11.97 7.86-2.77 1.82h.1l-7.1 4.67-4.83 3.17-4.2 2.76-40.85 26.84c-1.77 8.85-3.99 17.61-6.65 26.21l42.31-27.8 8.73-5.74 17.28-11.35 14.65 9.62-11.36 7.46-14.65 9.62-92.55 60.81z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SVGID_2_)"
      />
      <linearGradient
        id="SVGID_3_"
        gradientUnits="userSpaceOnUse"
        x1={892.4396}
        y1={933.1719}
        x2={1212.2457}
        y2={933.1719}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <path
        d="M984.67 993.48l-64.57-42.1a248.539 248.539 0 00-27.66-78.52l137.87 90.57-14.65 9.62-87.65-57.58a264.61 264.61 0 016.65 26.21l64.57 42.16-8.2 5.39h.1l-6.46 4.25z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SVGID_3_)"
      />
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1={989.1189}
        y1={953.5495}
        x2={1145.1626}
        y2={864.0519}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <path
        d="M1107.56 852.57l-114.79 75.4-14.65 9.62-8.94 5.87-7.69 5.05 4.83 3.17 7.1 4.67h-.1l2.77 1.82 7.75-5.09 8.94-5.87 14.65-9.62 64.57-42.42a264.61 264.61 0 00-6.65 26.21l-41.29 27.13 11.93 7.84h-.1l2.77 1.82 41.25-27.09a248.304 248.304 0 0127.65-78.51z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SVGID_4_)"
      />
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1={840.7293}
        y1={1049.5565}
        x2={995.488}
        y2={973.7489}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <path
        d="M929.58 968.32l-64.57 42.1a248.539 248.539 0 01-27.66 78.52l137.87-90.57-14.65-9.62-87.65 57.58a264.61 264.61 0 006.65-26.21l64.57-42.16-8.2-5.39h.1l-6.46-4.25z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="url(#SVGID_5_)"
      />
      <g>
        <path
          className="st5"
          d="M551.03 1292.31c-.17-4.05-.45-7.56-.83-10.54 4.52 2.13 8.57 3.63 12.17 4.51 3.6.87 7.06 1.31 10.38 1.31 3.2 0 6.17-.54 8.91-1.63 2.75-1.09 4.81-2.62 6.2-4.6 1.38-1.98 2.08-4.25 2.08-6.81 0-1.49-.23-2.89-.7-4.19-.47-1.3-1.23-2.62-2.27-3.96-1.04-1.34-2.85-3.15-5.43-5.43-2.58-2.28-6.23-5.42-10.96-9.43l-4.73-4.03a67.925 67.925 0 01-4.86-4.57c-1.45-1.51-2.66-2.96-3.64-4.35-.98-1.38-1.74-2.64-2.27-3.77s-.95-2.39-1.25-3.77c-.3-1.38-.45-2.8-.45-4.25 0-3.66 1-7.09 3-10.29 2-3.2 5.02-5.75 9.04-7.67 4.03-1.92 9.34-2.88 15.94-2.88 4.73 0 10.54.64 17.45 1.92.08 2.74.38 6.11.89 10.1-6.52-2.3-12.44-3.45-17.76-3.45-3.66 0-6.73.6-9.2 1.81-2.47 1.21-4.35 2.75-5.62 4.64s-1.92 3.83-1.92 5.82c0 1.19.17 2.35.51 3.48.34 1.13.85 2.2 1.53 3.23.98 1.49 2.19 2.99 3.64 4.51 1.45 1.51 3.45 3.35 6.01 5.53.64.51 3.08 2.51 7.32 6.01 4.24 3.49 7.33 6.2 9.27 8.12 1.94 1.92 3.48 3.7 4.63 5.34 1.15 1.64 2.04 3.41 2.68 5.3.64 1.9.96 3.95.96 6.17 0 3.41-.73 6.55-2.2 9.43s-3.58 5.23-6.33 7.06c-2.75 1.83-5.81 3.13-9.17 3.9-3.37.77-6.88 1.15-10.54 1.15-2.94 0-5.97-.22-9.11-.67-3.11-.47-7.57-1.48-13.37-3.05zM700.05 1294.61l1.28-19.55 1.72-40.51.57-18.72c-10.43.04-19.56.23-27.39.58.26-3.41.4-6.41.45-9.01 10.82.04 22.49.06 35.01.06l20.44-.06h10.86c-.3 3.78-.45 6.78-.45 9.01-6.6-.38-13.91-.58-21.92-.58h-5.24l-1.33 28.29-1.34 39.84v10.66l-6.14-.13c-.55-.01-2.72.03-6.52.12zM804.34 1294.61l11.63-21.98 29.65-57.96 3.45-7.28 7.42.06c2.3 0 4.8-.02 7.48-.06l11.05 31.31 20.44 55.91-6.07-.13c-1.15 0-3.43.04-6.84.13-1.15-4.09-3.05-10.01-5.71-17.76-2.66-7.75-4.9-14.04-6.73-18.85H835.2l-9.26 19.11-8.17 17.51-6.55-.13c-1.08-.01-3.37.03-6.88.12zm34.62-45.05h28.72l-11.87-33.8-16.85 33.8zM960.83 1294.61l11.63-21.98 29.65-57.96 3.45-7.28 7.42.06c2.3 0 4.8-.02 7.48-.06l11.05 31.31 20.44 55.91-6.07-.13c-1.15 0-3.43.04-6.84.13-1.15-4.09-3.05-10.01-5.71-17.76-2.66-7.75-4.9-14.04-6.73-18.85h-34.91l-9.26 19.11-8.17 17.51-6.55-.13c-1.07-.01-3.36.03-6.88.12zm34.63-45.05h28.72l-11.87-33.8-16.85 33.8zM1128.64 1294.61c.98-10.99 1.81-24.42 2.52-40.29.7-15.87 1.14-31.51 1.31-46.94 2.94.04 5.18.06 6.72.06l5.95-.06-2.04 40.48-1.53 38.18 12.14.06c9.03 0 15.39-.03 19.07-.1 3.68-.06 7.25-.2 10.7-.42-.26 2.7-.47 5.71-.64 9.01-9.67-.09-18.21-.13-25.62-.13l-28.58.15zM1258.81 1294.61l.96-14.7 1.34-30.61.89-30.16c.04-1.75.06-3.49.06-5.24l-.06-6.52 6.59.06 6.2-.06a868.96 868.96 0 00-1.72 33.36c-.68 18.57-1.17 36.53-1.47 53.87l-6.01-.13c-.77 0-3.03.04-6.78.13z"
        />
        <linearGradient
          id="SVGID_6_"
          gradientUnits="userSpaceOnUse"
          x1={1458.6719}
          y1={1251.1779}
          x2={1306.2605}
          y2={1250.7606}
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} />
        </linearGradient>
        <path
          d="M1342.26 1294.61c4.98-6.3 11.04-14.23 18.18-23.77 7.14-9.54 12.66-17.13 16.58-22.75l-7.54-12.72c-1.41-2.3-3.43-5.52-6.07-9.65l-6.39-9.9c-1.58-2.47-3.34-5.28-5.3-8.44 5.5.09 11.12.13 16.87.13 4.56 0 9.44-.04 14.63-.13 1.87 3.71 4.08 7.72 6.61 12.05 2.53 4.32 4.55 8.08 6.04 11.28 1.7-2.94 4.03-6.59 6.97-10.96 2.94-4.37 5.52-8.49 7.73-12.36 4.52.09 9.44.13 14.76.13 3.45 0 8.35-.04 14.7-.13-3.07 4.39-7.63 10.61-13.67 18.66-6.05 8.05-11.78 16-17.19 23.84 6.9 11.76 16.27 26.67 28.12 44.73-6.73-.08-11.78-.13-15.14-.13-5.62 0-11.18.04-16.68.13-1.66-3.41-3.99-7.72-7-12.94-3-5.22-5.61-10.02-7.83-14.41-1.66 2.98-4.39 7.18-8.18 12.59s-7.14 10.33-10.03 14.76c-6.22-.08-11.14-.13-14.76-.13-4.01-.01-9.14.03-15.41.12z"
          fill="url(#SVGID_6_)"
        />
      </g>
    </svg>
  
    </div>,
    document.getElementById('loader')
  )
}

export default Loader